import React, { Component } from "react";
import { Card, Badge, Button, Form, Modal, Tooltip, OverlayTrigger } from "react-bootstrap";
import { Redirect } from 'react-router-dom'
import MaterialTable from 'material-table'
import DeleteModal from './DeleteModal'
import axios from 'axios'
import { ThemeProvider } from '@material-ui/core'
import { createTheme } from '@material-ui/core/styles'
import CommonLoader from "./loaderComponent/CommonLoader";
import { downloadCSV } from "../utils/csvDownload";
import { hasPermission } from './../utils/usePermission';
import { customDownload } from "./../utils/customDownload";
import { DateTimeFormat } from "./DateFormat/DateTimeFormat";

export default class SalaryList extends Component {

  constructor(props) {
    super(props)
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = ("0" + (currentDate.getMonth() + 1)).slice(-2);
    this.state = {
      financialInformations: [],
      selectedUser: null,
      editRedirect: false,
      deleteModal: false,
      year: currentYear,
      month: currentMonth,
      loading: true
    }
  }
  csvDownload = () => {
    customDownload(this.state.financialInformations, `Salary_Info${this.state.year}/${this.state.month}`);
    // downloadCSV(this.state.financialInformations, `Salary_Info${this.state.year}/${this.state.month}`);
  }

  componentDidMount() {
    this.fetchData()
    // axios({
    //   method: 'get',
    //    url: `/financialInformations?year=${year}&month=${month}`,
    //   // url: '/financialInformations',
    //   headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    // })
    //   .then(res => {
    //     this.setState({ financialInformations: res.data })
    //   })
    //   .catch(err => {
    //     console.log(err)
    //   })
  }

  fetchData = () => {
    this.setState({ loading: true })
    const { year, month } = this.state;
    axios({
      method: "get",
      url: `salary/salarylist/${year}/${month}`,
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    })
      .then((res) => {
        this.setState({ financialInformations: res.data });
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      })
      .catch((err) => {
        console.log(err);
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      });
  };

  onEdit = (financialInfo) => {
    console.log("financialInfo", financialInfo);
    // this.props.history.push(`/edit-salary/${financialInfo?.empid}`)
    this.props.history.push({
      pathname: `/edit-salary/${financialInfo?.empid}`,
      state: { financialInfo }
    });
    // return (event) => {
    //   event.preventDefault()
    //   this.setState({ selectedUser: financialInfo.user, editRedirect: true })
    //   setTimeout(() => {
    //     this.setState({ loading: false });
    //   }, 900);
    // }
  }

  onView = (user) => {
    return (event) => {
      event.preventDefault()
      this.setState({ selectedUser: user, viewRedirect: true })
      setTimeout(() => {
        this.setState({ loading: false });
      }, 900);

    }
  }

  handleFilterChange = (event) => {
    this.setState({ [event.target.name]: event.target.value }, () => {
      this.fetchData();
    });
  };

  render() {

    const theme = createTheme({
      overrides: {
        MuiTableCell: {
          root: {
            padding: '6px 6px 6px 6px'
          }
        }
      }
    })

    return (
      <>
        <CommonLoader isLoading={this.state.loading}>
          <div className="container-fluid pt-4">
            {this.state.editRedirect ? (<Redirect to={{ pathname: '/salary-details', state: { selectedUser: this.state.selectedUser } }}></Redirect>) : (<></>)}
            {this.state.viewRedirect ? (<Redirect to={{ pathname: '/salary-view', state: { selectedUser: this.state.selectedUser } }}></Redirect>) : (<></>)}
            <div className="col-sm-12">
              <Card>
                <Card.Header style={{ backgroundColor: "#515e73", color: "white" }}>
                  <div className="panel-title">
                    <strong>List of Employees and Their Salaries</strong>
                  </div>
                </Card.Header>
                <Card.Body>

                  <Form className="mb-3 d-flex align-items-center">
                    <Form.Group className="mr-3">
                      <Form.Label>Year</Form.Label>
                      <Form.Control
                        as="select"
                        className="form-select"
                        name="year"
                        value={this.state.year}
                        onChange={this.handleFilterChange}
                      >
                        {[...Array(5)].map((_, index) => (
                          <option key={index} value={new Date().getFullYear() - index}>
                            {new Date().getFullYear() - index}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>Month</Form.Label>
                      <Form.Control
                        as="select"
                        className="form-select"
                        name="month"
                        value={this.state.month}
                        onChange={this.handleFilterChange}
                      >
                        {Array.from({ length: 12 }, (_, i) => {
                          const monthNumber = ("0" + (i + 1)).slice(-2);
                          return (
                            <option key={monthNumber} value={monthNumber}>
                              {monthNumber}
                            </option>
                          );
                        })}
                      </Form.Control>
                    </Form.Group>
                    <Form.Group className="mr-5 display-btn">
                      <Button
                        className="button-filter info"
                        variant="outline"
                        onClick={this.csvDownload}
                      // disabled={!this.state.project || (!this.state.startDate && !this.state.endDate && this.state.project !== "all")}
                      >
                        <i className="fas fa-file-csv"></i>
                      </Button>
                    </Form.Group>
                  </Form>
                  <ThemeProvider theme={theme}>
                    <MaterialTable
                      columns={[
                        { title: 'EMP ID', field: 'empid' },
                        { title: 'Full Name', field: 'employeeName' },
                        { title: 'Basic Salary', field: 'salaryBasic' },
                        { title: 'Gross Salary', field: 'salaryGross' },
                        { title: 'Net Salary', field: 'salaryNet' },
                        { title: 'No of Days Worked', field: 'TotalDaysWorked' },
                        { title: 'No of Rest Days', field: 'restdays' },
                        { title: 'Over time Hours', field: 'OtHours' },
                        { title: 'No of Leave Days', field: 'leavedays' },
                        { title: 'House Rent Allowance', field: 'allowanceHouseRent' },
                        { title: 'Medical Allowance', field: 'allowanceMedical' },
                        { title: 'Special Allowance', field: 'allowanceSpecial' },
                        { title: 'Fuel Allowance', field: 'allowanceFuel' },
                        { title: 'Food Allowance', field: 'allowancePhoneBill' },
                        { title: 'Other Expences', field: 'allowanceOther' },
                        { title: 'Provident Fund', field: 'deductionProvidentFund' },
                        { title: 'Deductions Tax', field: 'deductionTax' },
                        { title: 'Deductions Total', field: 'deductionTotal' },
                        { title: 'Other Deductions', field: 'deductionOther' },
                        { title: 'ESIC Amount', field: 'esicAmount' },
                        //{ title: 'Emp Type', field: 'employmentType' },
                        {
                          title: 'Payment Date', field: 'dateOfPayment',
                          render: rowData =>
                            rowData.dateOfPayment ? DateTimeFormat(rowData.dateOfPayment) : 'N/A'
                        },
                        {
                          title: 'Action',
                          render: rowData => (
                            <div style={{ display: 'flex' }}>
                              {hasPermission('M10S1B1') && (
                                <OverlayTrigger
                                  placement="top"

                                  overlay={<Tooltip id={`tooltip-edit-${rowData.id}`}>View Salary Details</Tooltip>}
                                >
                                  <Button size="sm" variant="outline-info" className="mr-2 info" onClick={this.onView(rowData)}><i className="far fa-eye"></i></Button>
                                </OverlayTrigger>
                              )}
                              {hasPermission('M10S1B2') && (
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip id={`tooltip-edit-${rowData.id}`}>Edit Salary Details</Tooltip>}
                                >
                                  <Button size="sm" variant="outline-info" className="mr-2 info" onClick={() => this.onEdit(rowData)}><i className="far fa-edit"></i></Button>
                                </OverlayTrigger>
                              )}
                            </div>
                          )
                        },
                        // {
                        //   title: 'Action',
                        //   render: rowData => (
                        //     <>
                        //       <Button size="sm" variant="outline-info" className="mr-2" onClick={this.onEdit(rowData)}><i className="far fa-edit"></i></Button>
                        //     </>
                        //   )
                        // }
                      ]}
                      // data={this.state.financialInformations}
                      data={this.state.financialInformations.map(({ tableData, ...rest }) => rest)}
                      options={{
                        rowStyle: (rowData, index) => {
                          if (index % 2) {
                            return { backgroundColor: '#f2f2f2' }
                          }
                        },
                        pageSize: 10,
                        pageSizeOptions: [10, 20, 30, 50, 75, 100]
                      }}
                      title="Employees"
                    />
                  </ThemeProvider>
                </Card.Body>
              </Card>
            </div>
          </div>
        </CommonLoader>
      </>
    );
  }
}